<template>
    <header>
        <div class="header">
            <nav class="first-half-header">
                <a style=" text-align: center;"  href="https://vk.com/board115982637">ЗАДАТЬ ВОПРОС</a>
                <a style="font-weight: 900;color: black;text-align: center" class="header-link"  href="/manual">Инструкции</a>
            </nav>
            <div>
                <a class="home-link" href="https://uni-dubna.ru">
                    <img src="../../assets/unilogo.png">
                </a>
            </div>
            <div class="second-half-header">

            </div>
        </div>
        <div class="title-container">
            <div>
                Электронная <br/>
                информационно-образовательная <br/>
                среда <br/>
                Университета "Дубна"<br/>
            </div>
        </div>


    </header>
</template>

<script>
    export default {
        name: "Head"
    }
</script>

<style scoped>
    header{
        min-height: 550px;
        background-position: center center;
        background-attachment: scroll;
        background-image: url("../../assets/фон_большой.jpg");
        background-size: cover;
        background-repeat: no-repeat;
    }

    .home-link img{
        width: 150px ;
    }

    .header{
        display: flex;
        justify-content: center;

    }
    a.header-link{
        font-family: 'PT Sans',Arial,sans-serif;
        text-align: center;
    }
    a.first-half-header{
        font-family: 'PT Sans',Arial,sans-serif;

    }

    .first-half-header, .second-half-header{
        width: 600px;
        height: 100px;
        box-sizing: border-box;
    }

    .first-half-header{
        padding-left: 20px;
        padding-right: 50px;
        text-align: left;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-family: 'PT Sans',Arial,sans-serif;
    }

    .first-half-header a, .header-link{
        color: #18224b;
        font-size: 18px;
        font-weight: 600;
        text-transform: uppercase;
        text-decoration: none;
        transition: 0.2s;
    }

    .first-half-header a:hover, .header-link:hover{
        color: #dc7d43 !important;
    }

    .title-container{
        width: 50%;
        text-align: left;
        display: flex;
        justify-content: flex-end;
    }

    .title-container{
        color: #18224b;
        font-size: 52px;
        font-family: 'Arial',Arial,sans-serif;
        line-height: 1.2;
        font-weight: 700;
        letter-spacing: 1px;
    }

    .title-container div{
        max-width: 620px;
    }

    @media (max-width: 1211px){
        header{
            min-height: 550px;
            background-position: center center;
            background-attachment: scroll;
            background-image: url("../../assets/фон_планшет.jpg");
            background-size: cover;
            background-repeat: no-repeat;
        }

        .title-container{
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            font-size: 37px;
        }

        .title-container div{
            max-width: 700px;
        }

        .home-link img{
            width: 100px ;
        }

        .first-half-header, .second-half-header{
            width: 400px;
            height: 100px;
            box-sizing: border-box;
        }

        .first-half-header{
            padding-left: 0px;
            padding-right: 50px;
            text-align: left;
            display: flex;
            justify-content: space-around;
            align-items: center;
        }

    }

    @media (max-width: 850px){
        header{
            background-image: url("../../assets/фон_мобильный-г.jpg");
            padding-top: 50px;
        }

        .header{
            display: none;
        }

        .title-container{
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            font-size: 20px;
        }

    }

</style>